import { ref, type Ref } from 'vue';
import type { IPopupService, IPopupViewModel, IPopupContext, PopupResult } from '@lingvo-news/contracts';

export class PopupServiceImpl implements IPopupService {
	private readonly currentPopupRef: Ref<IPopupViewModel<unknown> | null> = ref(null);
	private activeResolver: ((result: PopupResult<unknown>) => void) | null = null;

	get currentPopup(): IPopupViewModel<unknown> | null {
		return this.currentPopupRef.value;
	}

	async showPopup<TResult>(model: IPopupViewModel<TResult>): Promise<PopupResult<TResult>> {
		// Cancel any currently opened popup (best-effort).
		if (this.activeResolver) {
			this.activeResolver({ isCanceled: true });
			this.activeResolver = null;
		}
		this.currentPopupRef.value = null;

		return await new Promise<PopupResult<TResult>>((resolve) => {
			this.currentPopupRef.value = model as unknown as IPopupViewModel<unknown>;
			this.activeResolver = resolve as unknown as (result: PopupResult<unknown>) => void;

			const context: IPopupContext<TResult> = {
				closePopup: (result: TResult) => {
					this.currentPopupRef.value = null;
					const r = this.activeResolver as unknown as ((res: PopupResult<TResult>) => void) | null;
					this.activeResolver = null;
					r?.({ isCanceled: false, result });
				},
				cancelPopup: (result: TResult) => {
					this.currentPopupRef.value = null;
					const r = this.activeResolver as unknown as ((res: PopupResult<TResult>) => void) | null;
					this.activeResolver = null;
					r?.({ isCanceled: true, result });
				}
			};

			model.init(context);
		});
	}
}


